export default "__VITE_ASSET__mBHttxpg__"